<div>
  @if (isDisplayBannerInfo) {
    <mat-toolbar class="exclude-elem-to-order-directive">
      <h1>{{ 'banner_info.' + situation + '_' + role + roleModifiers + '_title' | translate }}</h1>
      <p>{{ 'banner_info.' + situation + '_' + role + roleModifiers + '_description' | translate }}</p>
    </mat-toolbar>
  }
</div>


